import { useResource } from "Infrastructure/Translation/Resources";
import { formatCurrency } from "Infrastructure/Utilities/currencyFormat";
import { Box, Stack, Typography } from "@mui/material";
import type { FC } from "react";

export enum ElementType {
	bar = "bar",
	breakpoint = "breakpoint",
}

export type ProgressElement = {
	color: string;
	label: string;
	value: number;
	type?: ElementType;
};

export const PaymentLegend: FC<{
	elements: ProgressElement[];
	currency: string;
	country: string;
}> = ({ elements, currency, country }) => {
	const { t } = useResource();
	return (
		<Stack spacing={1} mt={2} mb={1} width="100%">
			{elements.map(({ color, label, value }, index) => (
				<Stack
					key={`${index}-${value}`}
					flexDirection="row"
					alignItems="center"
					justifyContent="space-between"
				>
					<Stack flexDirection="row" alignItems="center" gap={1}>
						<Box
							sx={{
								width: 10,
								height: 10,
								borderRadius: "50%",
								backgroundColor: color,
							}}
						/>
						<Typography variant="body1">{t(label)}</Typography>
					</Stack>
					<Typography variant="body1">
						{formatCurrency(country, currency, value)}
					</Typography>
				</Stack>
			))}
		</Stack>
	);
};
